import type { ResourceProps } from '@refinedev/core'

import { dashboardResource } from './resources/dashboard'
import { orderManagementResources } from './resources/order-management'
import { returnManagementResources } from './resources/return-management'
import { cancellationManagementResources } from './resources/cancellation-management'
import { productManagementResources } from './resources/product-management'
import { settlementManagementResources } from './resources/settlement-management'

export const resources: ResourceProps[] = [
  dashboardResource,
  ...orderManagementResources,
  ...returnManagementResources,
  ...cancellationManagementResources,
  ...productManagementResources,
  ...settlementManagementResources,
]
